'use client';

import { useSharedModalAdapter, useSharedModalAdapterOptional } from '@module/helpers/modal/adapter';
import type { PandatvPcModalAdapter } from './ZustandModalAdapterProvider';

/** pandatv-pc 전용 타입이 박힌 모달 어댑터 훅. 호출부에서 제네릭 인자 없이 사용한다. */
export const useModalAdapter = () => {
  return useSharedModalAdapter();
};
export const useModalAdapterOptional = () => {
  return useSharedModalAdapterOptional();
};